import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialItem from './item';

export default class Materials extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const total = this.props.materials.reduce((acc, cur) => cur.subtotal ? acc + cur.subtotal : acc, 0);
    const finFieldsVisible = this.props.financialFieldsVisible;
    const finFieldsDisabled = this.props.financialFieldsDisabled;

    return (
      <div className="card rounded mb-3">
        <div className="card-header rounded-top">
          {this.props.labelPlural || 'Materials'}
        </div>
        <div className="card-block">
          <div className="row">
            <div className={finFieldsVisible ? "col col-lg-5 col-md-4 col-sm-4" : "col col-9"}>
              <label><b>Name</b></label>
            </div>
            <div className="col col-lg-1 col-md-2 col-sm-2">
              <label><b>Quantity</b></label>
            </div>
            <div className="col col-1">
              <label><b>Unit</b></label>
            </div>
            {finFieldsVisible && <div className="col col-2">
              <label><b>Price</b></label>
            </div>}
            {finFieldsVisible && <div className="col col-2">
              <label><b>Subtotal</b></label>
            </div>}
          </div>
          {
            this.props.materials.map((material, index) => (
              <MaterialItem
                key={material.id}
                isRemovable={this.props.materials.length !== (index + 1)}
                material={material}
                onChange={(field, value) => this.props.onChange(index, field, value)}
                vendors={this.props.vendors}
                financialFieldsVisible={finFieldsVisible}
                financialFieldsDisabled={finFieldsDisabled}
                disabled={this.props.disabled}
              />
            ))
          }
          {finFieldsVisible && <div className="row">
            <div className="col col-12">
              <label className="pull-right"><b>{this.props.labelPlural || 'Materials'} Total:</b></label>
            </div>
            <div className="col col-12">
              <label className="pull-right">{`$${total.toFixed(2)}`}</label>
            </div>
          </div>}
        </div>
      </div>
    );
  }
}

Materials.propTypes = {
  materials: PropTypes.array,
  vendors: PropTypes.array,
  onChange: PropTypes.func,
  financialFieldsVisible: PropTypes.bool,
  financialFieldsDisabled: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/common/Materials/index.js